export const clearAllData = (state) => {
  // Auth
  state.auth.isLoggedIn = false
  state.auth.user = {}

  // Accounts
  state.accounts.data = []
  state.accounts.meta = []

  // Themes
  state.themes.data = []
  state.themes.meta = []

  // Templates
  state.templates.data = []
  state.templates.meta = []

  // Users
  state.users.data = []
  state.users.meta = []
}

export const isLayerOpened = (state, isOpen) => {
  state.isLayerOpened = isOpen
}

export const locale = (state, newLocale) => {
  state.locale = newLocale
}

export const fullLocale = (state, newLocale) => {
  state.fullLocale = newLocale
}

export const scrollState = (state, { scrollKey, scrollPos }) => {
  state.scrollState[scrollKey] = scrollPos
}

export const searchState = (state, { searchKey, searchValue }) => {
  state.searchState[searchKey] = searchValue
}



// WEBPACK FOOTER //
// ./src/store/mutations.js